import { createPageWizardContext } from '../../components/EfficiencyWizard';
import { Step1DataProps, Step2DataProps } from './AssignReasonForm.types';

export interface AssignReasonFormContextProps {
  step1: Step1DataProps;
  step2: Step2DataProps;
}

export const AssignReasonFormContext = createPageWizardContext<AssignReasonFormContextProps>();
